import React, {FC} from "react";
import {Container} from "@mui/material";
import './style.css'
import {CustomerTextFlex, CustomerTextGrid, CustomerTextHead, CustomerTextP} from "./styles";

export const CardContentInfo: FC<{image?: string | undefined, title?: string | undefined, description?: string | undefined}> = ({ image, title, description }) => {
    return (
        <CustomerTextFlex id="content_wraper">
            <img src={image} alt={title} style={{ width: 38, height: 38, objectFit: "cover" }} />
            <div>
                <CustomerTextHead variant="h4" color="textPrimary">{title}</CustomerTextHead>
                <CustomerTextP variant="subtitle1" component="p" color="textPrimary">
                    {description}
                </CustomerTextP>
            </div>
        </CustomerTextFlex>
    )
}

export const CustomerText = () => {

    const contents = [
        {
            image: "https://static.secur.space/icons/security.png",
            title: "Find The Right Fit",
            description: " Search for available parking and storage space with the security, visibility and access that meets your needs."
        },
        {
            image: "https://static.secur.space/icons/calendar.png",
            title: "Flexible Arrangements",
            description: "Reserve and pay only for the capacity you need; no more long term commitments."
        },
        {
            image: "https://static.secur.space/icons/global.png",
            title: "Growing National Network",
            description: " Access a growing network of locations in every major transportation hub."
        },
    ]

    return (
        <Container maxWidth="lg" className="ss-customer-text">
            <CustomerTextGrid
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="space-between"
            >
                {contents.map((item, index) => (
                    <CardContentInfo key={index} {...item} />
                ))}
            </CustomerTextGrid>
        </Container>
    )
}
